import { FC, useState } from "react";
import { Box, TextField, InputAdornment } from "@mui/material";
import EyeSvg from "@/assets/svg/EyeSvg";
import { styles } from "./stylesCustomInput";

interface CustomInputProps {
  label: string;
  placeholder?: string;
  type?: string;
  error?: boolean;
  helperText?: string | null;
  startAdornment?: React.ReactNode;
  endAdornment?: React.ReactNode;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onFocus?: () => void;
  onBlur?: () => void;
  register?: any;
  name?: string;
  disabled?: boolean;
}

const CustomInput: FC<CustomInputProps> = ({
  label,
  placeholder,
  type = "text",
  error,
  helperText,
  startAdornment,
  endAdornment,
  register,
  name,
  value,
  onChange,
  onFocus,
  onBlur,
  disabled,
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const isPasswordField = type === "password";

  return (
    <Box sx={styles.wrapper}>
      <Box sx={styles.label}>{label}</Box>

      <TextField
        onFocus={onFocus}
        onBlur={onBlur}
        fullWidth
        disabled={disabled}
        type={isPasswordField ? (showPassword ? "text" : "password") : type}
        placeholder={placeholder}
        error={!!error}
        helperText={helperText}
        value={value}
        onChange={onChange}
        {...(register && name ? register(name) : {})}
        InputProps={{
          startAdornment: startAdornment ? (
            <InputAdornment
              position="start"
              sx={{
                marginRight: 0,
              }}
            >
              {startAdornment}
            </InputAdornment>
          ) : undefined,

          endAdornment: isPasswordField ? (
            <InputAdornment position="end">
              <Box
                {...styles.passwordAdornmentBox}
                onClick={() => setShowPassword((prev) => !prev)}
              >
                <EyeSvg crossed={!showPassword} />
              </Box>
            </InputAdornment>
          ) : (
            endAdornment
          ),
          sx: {
            "& .MuiInputBase-inputAdornedStart": {
              paddingLeft: "6px !important",
            },
            ...(styles.inputProps?.sx ?? {}),
          },
        }}
      />
    </Box>
  );
};

export default CustomInput;
